import theme from '../../theme';

export const RootSx = {
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  flexGrow: 1,
};

export const TitleSx = {
  fontSize: '26px',
  fontWeight: 'bold',
  marginTop: '12px',
  marginBottom: '6px',
  color: theme.palette.customColors.blue[950],
};

export const SubTitleSx = {
  fontSize: '16px',
  color: theme.palette.customColors.blue[950],
  marginBottom: '12px',
};
